import React from "react";

export default function FooterBar({ left, center, right }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-20 border-t border-neutral-200 bg-white/85 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 text-[12px] tracking-wide text-neutral-600">
        <button onClick={left?.onClick} className="hover:text-neutral-900">
          {left?.label ?? "LEFT"}
        </button>
        <button onClick={center?.onClick} className="hover:text-neutral-900">
          {center?.label ?? "CENTER"}
        </button>
        <button onClick={right?.onClick} className="hover:text-neutral-900">
          {right?.label ?? "RIGHT"}
        </button>
      </div>
    </div>
  );
}
